import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'th-no-content',
  templateUrl: './no-content.component.html',
  styleUrls: ['./no-content.component.scss']
})
export class NoContentComponent {
  loading = false;

  constructor(
    public authService: AuthService,
    activatedRoute: ActivatedRoute
  ) {
    this.loading = activatedRoute.snapshot.queryParamMap.get('loading') === 'true';
  }
}
